import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import { Spinner } from '@/components/ui/spinner'
import { faTimes } from '@/lib/fontAwesomePro/regular'
import { cn } from '@/lib/utils'

interface Props {
  children: React.ReactNode
  isHiding?: boolean
  variant: 'primary' | 'danger'
  /** Leave undefined to prevent hiding */
  onHide?: () => void
}

const Banner: React.FC<Props> = ({
  children,
  isHiding = false,
  variant,
  onHide,
}) => {
  function renderDismissButton() {
    if (isHiding) {
      return <Spinner className="hover-dim" />
    }

    if (onHide) {
      return (
        <FontAwesomeIcon
          onClick={onHide}
          icon={faTimes}
          className="text-lg"
          role="button"
          title="Dismiss"
        />
      )
    }

    return null
  }

  return (
    <section
      className={cn(
        `text-md flex items-center justify-center gap-12 p-4 text-center
        text-white`,
        variant === 'primary' ? 'bg-primary' : 'bg-destructive',
      )}
    >
      <div>{children}</div>

      {renderDismissButton()}
    </section>
  )
}

export default Banner
